import { render, staticRenderFns } from "./textList.vue?vue&type=template&id=e2e684fc&"
import script from "./textList.vue?vue&type=script&lang=ts&"
export * from "./textList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports